<template>
  <v-container>
    <v-btn
      v-if="orderFormView === 'edit'"
      text
      @click="$router.push('/dashboard')"
    >&leftarrow; Cancel</v-btn>
    <v-btn
      v-if="orderFormView === 'review'"
      text
      @click="orderFormView = 'edit'"
    >&leftarrow; Cancel</v-btn>
    <OrderFormEdit
      v-show="orderFormView === 'edit'"
      :orderType="orderType"
      @submit="orderFormView = 'review'"
    />
    <OrderFormReview
      v-if="orderFormView === 'review'"
      :orderType="orderType"
      @neworder="orderFormView = 'edit'"
    />
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import OrderFormEdit from "../../components/order-form/OrderFormEdit.vue"
import OrderFormReview from "../../components/order-form/OrderFormReview.vue"

export default {
  props: ["orderType"],
  components: {
    OrderFormEdit,
    OrderFormReview,
  },
  data() {
    return {
      showPreview: false,
      orderFormView: 'edit',
    }
  },
  computed: {
    ...mapState('order', ['order']),
    // orderFormView() {
    //   if (this.order) return 'review'
    //   else return 'edit'
    // }
  },
  methods: {
    hello() {
      // orderFormView === 'review'
      console.log('lalala')
    }
  },
  mounted() {
    console.log(this.orderType)
  },
}
</script>
